import React, { useState, useEffect, useContext } from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

import { Router } from "react-router";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";

const PREFIX = "Login";

const classes = {
  container: `${PREFIX}-container`,
  loginBtn: `${PREFIX}-loginBtn`,
  form: `${PREFIX}-form`,
  imageLogin: `${PREFIX}-imageLogin`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.container}`]: {
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    alignItems: "center",
    margin: `${theme.spacing(0)} auto`,
    [theme.breakpoints.down("xl")]: {
      flexWrap: "wrap",
    },
  },

  [`& .${classes.loginBtn}`]: {
    marginTop: theme.spacing(2),
    flexGrow: 1,
    borderRadius: 500,
    boxShadow: "none",
    fontSize: 18,
    marginLeft: 5,
    marginRight: 5,
    "&:hover": {
      //backgroundColor: StyleguideVandewieleColors.tints.blue[80],
    },
  },

  [`& .${classes.form}`]: {
    [theme.breakpoints.down("xl")]: {
      marginBottom: "10px",
      maxWidth: 300,
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: 300,
      marginRight: "10px",
    },
    [theme.breakpoints.up("lg")]: {},
  },

  [`& .${classes.imageLogin}`]: {
    width: "100%",
    [theme.breakpoints.down("xl")]: {
      maxWidth: 300,
    },
  },
}));

const Login = (props: any) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [helperText, setHelperText] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (username.trim() && password.trim()) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
    return () => {
      console.log("cleanup use effect login");
    };
  }, [username, password]);

  const handleLogin = () => {
    //if (username === 'abc@email.com' && password === 'password') {
    console.log("handle");
    if (username !== "" && password !== "") {
      setError(false);
      setHelperText("");

      // ServiceProvider.Auth.login(username, password)
      //   .then((resp) => {
      //     if (resp === true) {
      //       //props.history.push("/parts");
      //       window.location.reload();
      //     } else {
      //       setError(true);
      //       setHelperText("Incorrect username or password");
      //     }
      //   })
      //   .catch((error) => {
      //     throw error;
      //   });
    } else {
      setError(true);
      setHelperText("Incorrect username or password");
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13 || e.which === 13) {
      isButtonDisabled || handleLogin();
    }
  };

  return (
    <Root>
      <div className={classes.container}>
        <form noValidate autoComplete="off" className={classes.form}>
          <Card elevation={5}>
            {/* <CardHeader className={classes.header} title="Login App" /> */}
            <CardContent>
              <div style={{ textAlign: "center" }}>
                <img
                  style={{ width: "200px" }}
                  src={"/assets/images/Vandewiele.svg"}
                  alt="VDW"
                ></img>
                <TextField
                  error={error}
                  fullWidth
                  id="username"
                  type="email"
                  label="Username"
                  placeholder="Username"
                  margin="normal"
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
                <TextField
                  error={error}
                  fullWidth
                  id="password"
                  type="password"
                  label="Password"
                  placeholder="Password"
                  margin="normal"
                  helperText={helperText}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </div>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                size="large"
                color="secondary"
                className={classes.loginBtn}
                onClick={() => handleLogin()}
                disabled={isButtonDisabled}
              >
                Log In
              </Button>
            </CardActions>
          </Card>
        </form>
      </div>
    </Root>
  );
};

export default Login;
